/* ============================================================
   useToast.js — hook qui consomme le contexte ToastProvider
   ============================================================
   Sprint 2 P2 — design system global.

   Usage :
     const toast = useToast();
     toast.success('Import supprimé');
     toast.error('Erreur', { duration: 5000 });
     toast.warning('Action irréversible');
     toast.info('Mise à jour disponible');

   Le 2e argument optionnel { duration } override la durée par défaut
   (ms). Passer 0 pour désactiver l'auto-dismiss (variant error le fait
   déjà par défaut).
   ============================================================ */
import { useContext } from 'react';
import { ToastContext } from './ToastProvider';

export default function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error(
      'useToast must be used within ToastProvider. ' +
      'Wrap your app with <ToastProvider> in App.js.'
    );
  }
  return ctx;
}
